/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Label } from "./Label";
import {
  LabelFromJSON,
  LabelFromJSONTyped,
  LabelToJSON,
  LabelToJSONTyped,
} from "./Label";

/**
 *
 * @export
 * @interface LabelGroupWithLabels
 */
export interface LabelGroupWithLabels {
  /**
   *
   * @type {string}
   * @memberof LabelGroupWithLabels
   */
  labelGroupId: string;
  /**
   *
   * @type {string}
   * @memberof LabelGroupWithLabels
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof LabelGroupWithLabels
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof LabelGroupWithLabels
   */
  color: string;
  /**
   *
   * @type {Array<Label>}
   * @memberof LabelGroupWithLabels
   */
  labels: Array<Label>;
}

/**
 * Check if a given object implements the LabelGroupWithLabels interface.
 */
export function instanceOfLabelGroupWithLabels(
  value: object,
): value is LabelGroupWithLabels {
  if (!("labelGroupId" in value) || value["labelGroupId"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("color" in value) || value["color"] === undefined) return false;
  if (!("labels" in value) || value["labels"] === undefined) return false;
  return true;
}

export function LabelGroupWithLabelsFromJSON(json: any): LabelGroupWithLabels {
  return LabelGroupWithLabelsFromJSONTyped(json, false);
}

export function LabelGroupWithLabelsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LabelGroupWithLabels {
  if (json == null) {
    return json;
  }
  return {
    labelGroupId: json["labelGroupId"],
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    color: json["color"],
    labels: (json["labels"] as Array<any>).map(LabelFromJSON),
  };
}

export function LabelGroupWithLabelsToJSON(json: any): LabelGroupWithLabels {
  return LabelGroupWithLabelsToJSONTyped(json, false);
}

export function LabelGroupWithLabelsToJSONTyped(
  value?: LabelGroupWithLabels | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    labelGroupId: value["labelGroupId"],
    title: value["title"],
    description: value["description"],
    color: value["color"],
    labels: (value["labels"] as Array<any>).map(LabelToJSON),
  };
}
